import { createSelector } from "@reduxjs/toolkit";
import type { BookingSettingsState } from "./booking-settings.models";

type BookingSettingsRootSlice = { bookingSettings: BookingSettingsState };

const selectBookingSettingsState = (state: BookingSettingsRootSlice) => state.bookingSettings;

export const selectBookingSettingsData = createSelector(
  [selectBookingSettingsState],
  (s) => s.data,
);

export const selectBookingSettingsLoading = createSelector(
  [selectBookingSettingsState],
  (s) => s.loading,
);

export const selectBookingSettingsError = createSelector(
  [selectBookingSettingsState],
  (s) => s.error,
);

export const selectBookingSettingsSaving = createSelector(
  [selectBookingSettingsState],
  (s) => s.saving,
);

export const selectBookingSettingsSaveError = createSelector(
  [selectBookingSettingsState],
  (s) => s.saveError,
);
